/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import { useEffect } from "react";
import AuthenticationClient from "../../../../Basis/Authentication/AuthenticationClient";
import LoadingIndicator from "../../../../Basis/Components/LoadingIndicator";

export default function LogoutRedirect() {
    const authenticationClient = new AuthenticationClient();

    useEffect(() => {
        authenticationClient
            .logout()
            .then(resp => {
                if (resp.ok) {
                    window.location.href = "/";
                    if (sessionStorage.schnelleinstieg) {
                        sessionStorage.schnelleinstieg.ueberspringen = undefined;
                    }
                }
            })
    }, []);

    return <LoadingIndicator loading></LoadingIndicator>;
}